import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { DateNavigator } from 'modules/core/components/DateNavigator'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import {
  Cycle,
  useAttendanceDateNavigator,
} from 'modules/attendance/lib/attendanceDateNavigatorContext'

export interface DatePickerProps {
  regularPeriods: ('day' | 'week' | 'fortnight' | 'month')[]
  onChange?: (from: Date, to: Date, cycle: Cycle) => void
}

const TimeTrackingDatePicker = ({ regularPeriods, onChange }: DatePickerProps) => {
  const { dateFrom, dateTo, cycle, onDateChange } = useAttendanceDateNavigator()
  const { pathname } = useLocation()

  const onPeriodChange = (newRange: [Date, Date]) => {
    const [newDateFrom, newDateTo, newCycle] = onDateChange(newRange)

    if (onChange) onChange(newDateFrom, newDateTo, newCycle)

    if (cycle !== newCycle) {
      track(trackingEvents.timeTracking.periodChangedFromDateNavigator, {
        old_period_type: cycle,
        new_period_type: newCycle,
        path: pathname,
      })
    }
  }

  return (
    <DateNavigator
      regularPeriods={regularPeriods}
      startDate={dateFrom}
      endDate={dateTo}
      onDateRangeChange={(...newRange) => onPeriodChange(newRange)}
    />
  )
}
export default TimeTrackingDatePicker
